<section class="section-header content-padding negative-padding-offset {{ classes }}">
  <div class="container-fluid">
    <div [ngClass]="{'mobile-next-line': mobileContentNextLine === true, 'd-flex justify-content-between': mobileContentNextLine === false, 'mobile-hide-title': mobileHideTitle}">
      <div class="logo-wrapper">
        <img src="assets/images/Gilmore_Gas_logo.png"
             alt="Gilmore Gasoline"
             class="logo" *ngIf="showGasLogo">
        <h2 *ngIf="!!title" class="h4 section-header-title" [ngClass]="{'withLogo': showGasLogo}" [style.min-width]="minTitleWidth" [innerHTML]=" title"></h2>
      </div>
      <h3 *ngIf="!!subTitle && subTitle !== ''" class="h5 section-header-subtitle" [innerHTML]="subTitle"></h3>

      <!-- transclude content -->
      <div [ngClass]="{'d-none d-lg-block': mobileContentNextLine === true, 'd-block': mobileContentNextLine === false}">
        <ng-content select=".desktop"></ng-content>
        <ng-content></ng-content>
      </div>

      <button *ngIf="!!buttonText && buttonUrl.indexOf('/') === 0" class="btn {{ buttonClass }} d-none d-sm-block" type="submit" [routerLink]="buttonUrl" [queryParams]="buttonParams">{{ buttonText }}</button>
      <button *ngIf="!!buttonText && buttonUrl.indexOf('/') !== 0" class="btn {{ buttonClass }} d-none d-sm-block" type="submit" (click)="goto($event, buttonUrl)">{{ buttonText }}</button>
    </div>

    <!-- transclude content -->
    <div [ngClass]="{'d-block d-lg-none': mobileContentNextLine === true, 'd-none': mobileContentNextLine === false}">
      <ng-content select=".mobile"></ng-content>
    </div>
  </div>
</section>
